export class RgpdResponseDTO {
    isInformationValid: boolean;
    canTakePhotos: boolean;
    isRGPDReaded: boolean;
    canContactResponsable: boolean;
    idYear: number;
    comeAlone: boolean;
}
